import { FC, useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'

import CONFIG from '../../../../config'
import { Layout } from '../../../containers'
import { Button, Card, Input, Title, Table, Icon, Loading, Paginate, Text, CircleStatus } from '../../../components/UI'
import { Modal, useModal } from '../../../components/UI/Modal'
import { userService } from '../../../services'
import { useUserStatus, useAuth } from '../../../hooks'

interface IUsersSearchForm {
  searchTerm: string
}

const pageDefault: number = 1

const AdminUsersPage:FC = ()  => {
  const { register, handleSubmit, getValues } = useForm<IUsersSearchForm>()
  const [users, setUsers] = useState<any>({})
  const [user, setUser] = useState<any>({})
  const userStatus = useUserStatus()
  const userCurrent = useAuth()
  const [pageCurrent, setPageCurrent] = useState<number>(pageDefault)
  const [filterStatus, setFilterStatus] = useState<number>(0)
  const [recoveryPasswordSw, setRecoveryPasswordSw] = useState<boolean>(false)
  const [recoveryPasswordSubmited, setRecoveryPasswordSubmited] = useState<boolean>(false)
  const [submited, setSubmited] = useState<boolean>(false)
  const modalStatus = useModal()
  const modalPassword = useModal()

  useEffect(() => {
    setUsersSearch()
  }, [])

  const getSearchTerm = (): string => getValues('searchTerm')

  const setUsersSearch = async (filter: string = '', status: number = 0, page: number = 1) => {
    setSubmited(true)
    const usersData = await userService.getUsers(filter, status, page)

    setUsers(usersData.data)
    setSubmited(false)
  }

  const delUser = async (id: number) => {
    setSubmited(true)
    const resp = await userService.delUser(id)
    setSubmited(false)

    if(resp && resp.status === 'Ok') {
      setUsersSearch(getSearchTerm(), filterStatus, pageCurrent)
    }
  }

  const isUserCurrentByRole = (role: string = CONFIG.AUTH.ROLES.SUPERADMIN) => {
    const { rol } = userCurrent.getInfo()
    return (rol === role)
  }

  const postUserRecoveryPassword = async (documentTypeId: number, documentNumber: string) => {
    setRecoveryPasswordSubmited(true)
    const resp = await userService.postUserRecoveryPassword(documentTypeId, documentNumber)

    if(resp && resp.status === 'Ok') {
      setRecoveryPasswordSw(true)

      setTimeout(() => {
        modalPassword.close()
        setRecoveryPasswordSubmited(false)
      }, 3000);
    } else {
      setRecoveryPasswordSubmited(false)
    }
  }

  const tableColumns = [
    {
      accessor: 'document_number',
      Header: 'RUN o Pasaporte',
      width: '16%'
    },
    {
      accessor: 'first_name',
      Header: 'Nombres',
      width: '16%'
    },
    {
      accessor: 'last_name',
      Header: 'Primer apellido',
      width: '16%'
    },
    {
      accessor: 'second_name',
      Header: 'Segundo apellido',
      width: '17%'
    },
    {
      accessor: 'status_data.name',
      Header: 'Estado',
      width: '17%',
      filter: (userStatus.data ? userStatus.data : []),
      Cell: (params: any) => {
        const { original } = params.row

        return (
          <div className="d-flex align-items-center justify-content-between">
            <span className="text-capitalize">{params.value}</span>
            <CircleStatus status={original.status_data.id} />
          </div>
        )
      }
    },
    {
      accessor: 'action',
      Header: 'Acción',
      width: '25%',
      Cell: (params: any) => {
        const { original } = params.row

        return (
          <div className="d-flex">
            <Button component="link" to={`${CONFIG.ROUTES.ADMIN.USERS.EDIT}/${original.id}`} mode="circle" size="sm">
              <Icon name="edit" />
            </Button>
            {original.status_data_id !== 2 &&
              <Button mode="circle" size="sm" className="ml-5" onClick={() => onModalShow(original)}>
                <Icon name="disabled" />
              </Button>
            }
            <Button size="sm" className={`${original.status_data_id === 2 ? 'ml-auto' : 'ml-5' }`} onClick={() => onModalShow(original, 'PASSWORD')}>CON. TEMPORAL</Button>
          </div>
        )
      }
    }
  ]

  const onSearchPageCurrent = (pageCurrent: number) => {
    setPageCurrent(pageCurrent)
    setUsersSearch(getSearchTerm(), filterStatus, pageCurrent)
  }

  const onSearchSubmit = (data: IUsersSearchForm) => {
    const { searchTerm } = data
    setPageCurrent(pageDefault)
    setUsersSearch(searchTerm, filterStatus, pageDefault)
  }

  const onModalShow = (user: any, modal: 'STATUS' | 'PASSWORD' = 'STATUS') => {
    setUser(user)

    if(modal === 'STATUS') modalStatus.open()
    else if(modal === 'PASSWORD') {
      setRecoveryPasswordSubmited(false)
      modalPassword.open()
      setRecoveryPasswordSw(false)
    }
  }

  const onUserDelete = () => {
    const { id } = user

    delUser(id)
    modalStatus.close()
  }

  const onUserRecoveryPassword = () => {
    const { document_type_id, document_number } = user

    postUserRecoveryPassword(document_type_id, document_number)
  }

  const onTableFilterChange = (statusId: number) => {
    setPageCurrent(pageDefault)
    setFilterStatus(statusId)
    setUsersSearch(getSearchTerm(), statusId, pageDefault)
  }

  return (
    <Layout role="ADMIN_ROLE" menu={true}>
      <Title border>Administrador de usuarios</Title>

      <Card className="mt-50 py-20 px-70">
        <form noValidate autoComplete="off" onSubmit={handleSubmit(onSearchSubmit)}>
          <div className="d-flex">
            <div style={{ flex:'0 0 170px', maxWidth: '170px' }}>
              <Button component="link" size="md" to={CONFIG.ROUTES.ADMIN.USERS.CREATE.PATIENT}>CREAR PACIENTE</Button>
            </div>
            {isUserCurrentByRole() &&
              <div style={{ flex:'0 0 200px', maxWidth: '200px' }}>
                <Button component="link" size="md" to={CONFIG.ROUTES.ADMIN.USERS.CREATE.ADMIN}>CREAR ADMINISTRADOR</Button>
              </div>
            }
            <div className="col pl-0" style={{ width: '100%' }}>
              <Input
                {...register('searchTerm')}
                placeholder="Escribe aquí el usuario que buscas"
                version="2"
                icon="search"
                fullWidth
              />
            </div>
            <div style={{ flex:'0 0 85px', maxWidth: '85px' }}>
              <Button
                type="submit"
                size="md"
                disabled={submited}
              >BUSCAR</Button>
            </div>
          </div>
        </form>

        <div className="position-relative mt-30" style={{ minHeight: 150 }}>
          <Table
            columns={tableColumns}
            data={users && users.patients ? users.patients : []}
            onFilterChange={(statusId) => onTableFilterChange(parseInt(statusId))}
          />
          {submited && <Loading overlay />}
        </div>

        <div className="text-center mt-20">
          <Paginate current={pageCurrent} total={users ? users.count : 0} onPageChange={(current) => onSearchPageCurrent(current)} />
        </div>
      </Card>

      <Modal show={modalStatus.show} maxWidth="345px" onClose={() => modalStatus.close()}>
        <div className="text-center pt-70 pb-60 px-50">
          <Text component="label" size="20" weight="bold">¿Estas seguro(a) que deseas deshabilitar a este usuario?</Text>

          <div className="mt-40">
            <Button fullWidth onClick={onUserDelete}>SÍ, DESHABILITAR</Button>
            <Button fullWidth className="mt-10" onClick={() =>  modalStatus.close()}>NO, CANCELAR</Button>
          </div>
        </div>
      </Modal>

      <Modal show={modalPassword.show} maxWidth="345px" onClose={() => modalPassword.close()}>
        <div className="text-center py-60 px-20">
          <Text component="label" size="20" weight="bold">¿Olvidó la clave?</Text>
          <Text size="14" lineHeight="6" className="mt-15">Le enviaremos un mensaje de correo electrónico con una constraseña temporal a:</Text>
          <Text size="14" weight="bold" lineHeight="6" className="mt-15">{user.email}</Text>
          {recoveryPasswordSw && <Text size="14" color="primary" lineHeight="6" className="mt-15">¡Contraseña temporal enviada exitosamente!</Text>}

          <div className="mt-20 px-20">
            <Button fullWidth disabled={recoveryPasswordSubmited} onClick={onUserRecoveryPassword}>SÍ, ENVIAR</Button>
            <Button fullWidth className="mt-10" onClick={() => modalPassword.close()}>NO, CANCELAR</Button>
          </div>
        </div>
      </Modal>
    </Layout>
  )
}

export { AdminUsersPage }